import React from 'react';
import {
    CastAndCrewHeading,
    ListHeading,
    Name,
    StyledCastAndCrew,
    CastAndCrewLists,
    CastAndCrewSection,
    CastAndCrewLink,
    CastAndCrewUl,
} from './CastAndCrew.styles';
import Link from 'next/link';

const CastAndCrew = ({ castAndCrew }) => {
    if (!castAndCrew || castAndCrew.length < 1) {
        return null;
    }

    return (
        <StyledCastAndCrew>
            <CastAndCrewHeading>Medverkande och kreatörer</CastAndCrewHeading>
            <CastAndCrewLists>
                {castAndCrew.map((castCrew) => {
                    return (
                        <CastAndCrewSection key={`cast-crew-section-${castCrew.name}`}>
                            <ListHeading>{castCrew.name}</ListHeading>
                            <CastAndCrewUl>
                                {castCrew.people.map((person) => (
                                    <Name as="li" key={`cast-crew-${person.name}`}>
                                        {person.numberOfParticipations > 1 ? (
                                            <Link passHref href={`/sok?q=${person.name}`}>
                                                <CastAndCrewLink>{person.name}</CastAndCrewLink>
                                            </Link>
                                        ) : (
                                            <span>{person.name}</span>
                                        )}
                                    </Name>
                                ))}
                            </CastAndCrewUl>
                        </CastAndCrewSection>
                    );
                })}
            </CastAndCrewLists>
        </StyledCastAndCrew>
    );
};

export default CastAndCrew;
